import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-b2',
  templateUrl: './add-b2.component.html',
  styleUrl: './add-b2.component.css'
})
export class AddB2Component implements OnInit {
  b2Form!: FormGroup;
  optionsMap: { [key: string]: any[] } = {
    countries: [{ value: 'India', label: 'India' }],
    states: [],
    districts: [],
    subDistricts: [],
    villages: [],
  };
  fields = [
    { key: 'clientName', label: 'Client Name', type: 'text', value: '', required: true },
    { key: 'contactPerson', label: 'Contact Person', type: 'text', value: '' },
    { key: 'contactNo', label: 'Contact No.', type: 'text', value: '' },
    { key: 'COUNTRY', label: 'Country', type: 'select', value: '', optionKey: 'countries', onChange: () => this.onCountryStateChange(), required: true },
    { key: 'STATE', label: 'State', type: 'select', value: '', optionKey: 'states', onChange: () => this.onStateChange(), required: true },
    { key: 'district', label: 'District', type: 'select', value: '', optionKey: 'districts', onChange: () => this.onStatedistrictsChange(), required: true },
    { key: 'tehsil', label: 'Tehsil', type: 'select', value: '', optionKey: 'subDistricts', onChange: () => this.onStatedistrictssubDistrictsChange(), required: true },
    { key: 'village', label: 'Village', type: 'select', value: '', optionKey: 'villages', required: true },
    { key: 'khasraNo', label: 'Khasra No.', type: 'text', value: '' },
    { key: 'area', label: 'Area', type: 'text', value: '' },
    { key: 'entryDate', label: 'Entry Date', type: 'date', value: '' },
    { key: 'category', label: 'Category (B1/B2)', type: 'text', value: '' },
    { key: 'ecMp', label: 'EC/MP', type: 'text', value: '' },
    { key: 'mpStatus', label: 'MP Status', type: 'text', value: '' },
    { key: 'rqp', label: 'RQP', type: 'text', value: '' },
    { key: 'leaseValidity', label: 'Lease Validity', type: 'text', value: '' },
    { key: 'mpPeriod', label: 'MP Plan Period', type: 'text', value: '' },
    { key: 'blasting', label: 'Blasting/Non Blasting', type: 'text', value: '' },
    { key: 'mineral', label: 'Mineral', type: 'text', value: '' },
    { key: 'fileStatus', label: 'File Status', type: 'text', value: '' },
    { key: 'filePreparedBy', label: 'File Prepared By', type: 'text', value: '' },
    { key: 'productionDetails', label: 'Production Details', type: 'text', value: '' },
    { key: 'onlineDate', label: 'Online Date', type: 'date', value: '' },
    { key: 'proposalNo', label: 'Proposal No', type: 'text', value: '' },
    { key: 'caseNo', label: 'Case No', type: 'text', value: '' },
    { key: 'seacDate', label: 'SEAC Agenda Date', type: 'date', value: '' },
    { key: 'pptStatus', label: 'PPT Status', type: 'text', value: '' },
    { key: 'seacMinutes', label: 'SEAC Minutes', type: 'text', value: '' },
    { key: 'seacAdsStatus', label: 'SEAC ADS Case Status', type: 'text' },
    { key: 'seacAdsDate', label: 'SEAC ADS Date', type: 'date', value: '' },
    { key: 'seiaaDate', label: 'SEIAA Agenda Date', type: 'date', value: '' },
    { key: 'pptApproved', label: 'PPT Approved', type: 'text' },
    { key: 'seiaaAdsStatus', label: 'SEIAA ADS Status', type: 'text', value: '' },
    { key: 'seiaaAgendaDate', label: 'SEIAA Agenda Date', type: 'date', value: '' },
    { key: 'seiaaMinutes', label: 'SEIAA Minutes', type: 'text', value: '' },
    { key: 'ecStatus', label: 'EC Status', type: 'text', value: '' },
    { key: 'folderLink', label: 'Folder Link', type: 'text', value: '' },
    { key: 'kml', label: 'KML', type: 'text', value: '' },
    { key: 'remark', label: 'Remark', type: 'text', value: '' }
  ];

  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService,) { }

  ngOnInit(): void {
    const group: any = {};
    this.fields.forEach(field => {
      group[field.key] = field.required ? [field.value || '', Validators.required] : [field.value || ''];
    });
    this.b2Form = this.fb.group(group);
  }

  onSubmit(): void {
    if (this.b2Form.invalid) {
      this.b2Form.markAllAsTouched();
      return;
    }

    console.log('Form submitted:', this.b2Form.value);
  }
  onCountryStateChange() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.optionsMap['states'] = (res as any[]).map(state => ({
          value: state,
          label: state
        }));
        this.b2Form.get('state')?.setValue('');
        this.optionsMap['districts'] = [];
      },
      error: (err) => this.toastrMsgService.error(err.error.errorMessage)
    });
  }

  onStateChange() {
    const selectedState = this.b2Form.get('state')?.value;
    console.log(selectedState)
    if (selectedState) {
      this.apiService.getdistricts(selectedState).subscribe({
        next: (res) => {
          this.optionsMap['districts'] = (res as any[]).map(city => ({
            value: city,
            label: city
          }));
          this.b2Form.get('district')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }
  }
  onStatedistrictsChange() {
    const state = this.b2Form.value.state;
    const district = this.b2Form.value.district;
     if (district) {
      this.apiService.getSubdistricts(state,district).subscribe({
        next: (res) => {
          this.optionsMap['subDistricts'] = (res as any[]).map(subDis => ({
            value: subDis,
            label: subDis
          }));
          this.b2Form.get('tehsil')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }

  }
  onStatedistrictssubDistrictsChange() {
      const state = this.b2Form.value.state;
    const district = this.b2Form.value.district;
    const subdistrict = this.b2Form.value.tehsil;
     if (subdistrict) {
      this.apiService.getvillages(state,district,subdistrict).subscribe({
        next: (res) => {
          this.optionsMap['villages'] = (res as any[]).map(vill => ({
            value: vill,
            label: vill
          }));
          this.b2Form.get('village')?.setValue('');
        },
        error: (err) => this.toastrMsgService.error(err.error.errorMessage)
      });
    }

  }


  generateDummyData() {
  const dummyData: any = {};
  this.fields.forEach(field => {
    switch (field.type) {
      case 'text':
        dummyData[field.key] = `${field.label} Sample`;
        break;
      case 'date':
        dummyData[field.key] = new Date().toISOString().substring(0, 10); 
        break;
      case 'select':
        dummyData[field.key] = 'SampleOption'; 
        break;
      default:
        dummyData[field.key] = '';
    }
  });
  return dummyData;
}

}